@if (event) {
  <div class="card card-event">
    <div class="row m-0">
      @if (event.is_recurring) {
        <div class="card-event-label">
          <span>{{ 'global.multiple_days' | transloco }}</span>
        </div>
      }
      @if (event?.photo?.url1x) {
        <div
          class="event-background"
          [ngStyle]="{
            'background-image': 'url(' + event.photo.url1x + '?w=500&h=370&m=2' + addWebp + ')',
          }"
        ></div>
      } @else {
        @if (event?.banner?.url1x) {
          <div
            class="event-background"
            [ngStyle]="{
              'background-image': 'url(' + event.banner.url1x + '?w=500&h=370&m=2' + addWebp + ')',
            }"
          ></div>
        } @else {
          <div class="event-background">
            <span class="icon" [inlineSVG]="'/icons/event.svg'"></span>
          </div>
        }
      }
    </div>
    <div class="row m-0">
      <div class="card-event-body d-flex flex-column">
        <div class="m-0 p-3 w-100">
          <p class="card-title dot mb-1">
            <span class="font-weight-bold title hyphenate-container hyphenate" lang="nl">{{ event.name }}</span>
          </p>
          @if (event.external_types) {
            <p class="mb-1 icon-container">
              @for (type of event.external_types?.split('|'); track type) {
                <lib-event-icon [eventType]="type"></lib-event-icon>
              }
              &nbsp;
            </p>
          }
          @if (event.street && event.city) {
            <p class="mb-1">
              <span class="icon" [inlineSVG]="'/icons/no-stroke-icon-address.svg'"></span>
              {{ event.street }}{{ event.house_number ? ' ' + event.house_number : '' }}, {{ event.city }}
            </p>
          }
          <p class="font-weight-bold date mb-1">
            @if (!isSameDay) {
              <span
                >{{ event.available_from | date: 'dd MMM yyyy HH:mm' }}
                @if (event.available_to) {
                  -
                  {{ event.available_to | date: 'dd MMM yyyy HH:mm' }}
                }
              </span>
            }
            @if (isSameDay) {
              <span>
                {{ event.available_from | date: 'dd MMM yyyy HH:mm' }}
                @if (event.available_to) {
                  - {{ event.available_to | date: 'HH:mm' }}
                }
              </span>
            }
          </p>
        </div>
      </div>
    </div>
  </div>
}
